<template>
<div class="chapter">
<div class="inner_page">
<div class="sidebar">
<h2 class="chapter_title"><a id="page_8"></a><a id="page_9"></a><a id="ch1"></a>CHAPTER 1</h2>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/colorline.jpg"/></p>
</div>
<h2 class="chapter_title">BIRTHDAYS</h2>
<p class="first1_noindent">The day you were born has a formidable hand in determining both your personality and the direction your life will take. Find the fortune for your own birthday below, or look to the birthdays of friends, family members, and others to learn more about them.</p>
</div>
<table border="1" cellpadding="0" cellspacing="0" width="100%">
<tbody><tr>
<td valign="top"><p class="table"><a id="page_10"></a>MONTH</p></td>
<td valign="top"><p class="table">BIRTHSTONE (AND<br/>MEANING)</p></td>
<td valign="top"><p class="table">FLOWER</p></td>
<td valign="top"><p class="table">COLORS</p></td>
</tr>
<tr>
<td valign="top"><p class="first2_noindent">January</p></td>
<td valign="top"><p class="first2_noindent">Garnet (constancy)</p></td>
<td valign="top"><p class="first2_noindent">Carnation</p></td>
<td valign="top"><p class="first2_noindent">Black, dark blue, and red</p></td>
</tr>
<tr>
<td valign="top"><p class="first2_noindent">February</p></td>
<td valign="top"><p class="first2_noindent">Amethyst (sincerity)</p></td>
<td valign="top"><p class="first2_noindent">Violet</p></td>
<td valign="top"><p class="first2_noindent">Light blue and yellow</p></td>
</tr>
<tr>
<td valign="top"><p class="first2_noindent">March</p></td>
<td valign="top"><p class="first2_noindent">Bloodstone (courage)</p></td>
<td valign="top"><p class="first2_noindent">Jonquil</p></td>
<td valign="top"><p class="first2_noindent">White and light blue</p></td>
</tr>
<tr>
<td valign="top"><p class="first2_noindent">April</p></td>
<td valign="top"><p class="first2_noindent">Diamond (innocence)</p></td>
<td valign="top"><p class="first2_noindent">Sweet pea</p></td>
<td valign="top"><p class="first2_noindent">Yellow and red</p></td>
</tr>
<tr>
<td valign="top"><p class="first2_noindent">May</p></td>
<td valign="top"><p class="first2_noindent">Emerald (success in love)</p></td>
<td valign="top"><p class="first2_noindent">Lily of the valley</p></td>
<td valign="top"><p class="first2_noindent">Yellow, red, and green</p></td>
</tr>
<tr>
<td valign="top"><p class="first2_noindent">June</p></td>
<td valign="top"><p class="first2_noindent">Pearl (health)</p></td>
<td valign="top"><p class="first2_noindent">Rose</p></td>
<td valign="top"><p class="first2_noindent">White, cream, and light blue</p></td>
</tr>
<tr>
<td valign="top"><p class="first2_noindent">July</p></td>
<td valign="top"><p class="first2_noindent">Ruby (contented mind)</p></td>
<td valign="top"><p class="first2_noindent">Larkspur</p></td>
<td valign="top"><p class="first2_noindent">Green, russet, and red</p></td>
</tr>
<tr>
<td valign="top"><p class="first2_noindent">August</p></td>
<td valign="top"><p class="first2_noindent">Sardonyx (conjugal felicity)</p></td>
<td valign="top"><p class="first2_noindent">Gladioli</p></td>
<td valign="top"><p class="first2_noindent">Orange, red, and light green</p></td>
</tr>
<tr>
<td valign="top"><p class="first2_noindent">September</p></td>
<td valign="top"><p class="first2_noindent">Sapphire (love)</p></td>
<td valign="top"><p class="first2_noindent">Aster</p></td>
<td valign="top"><p class="first2_noindent">Brown and dark blue</p></td>
</tr>
<tr>
<td valign="top"><p class="first2_noindent">October</p></td>
<td valign="top"><p class="first2_noindent">Opal (hope)</p></td>
<td valign="top"><p class="first2_noindent">Calendula</p></td>
<td valign="top"><p class="first2_noindent">White and yellow</p></td>
</tr>
<tr>
<td valign="top"><p class="first2_noindent">November</p></td>
<td valign="top"><p class="first2_noindent">Topaz (fidelity)</p></td>
<td valign="top"><p class="first2_noindent">Chrysanthemum</p></td>
<td valign="top"><p class="first2_noindent">Dark blue, red, and yellow</p></td>
</tr>
<tr>
<td valign="top"><p class="first2_noindent">December</p></td>
<td valign="top"><p class="first2_noindent">Turquoise (prosperity)</p></td>
<td valign="top"><p class="first2_noindent">Narcissus</p></td>
<td valign="top"><p class="first2_noindent">Indigo, blue-green, and green</p></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06-part01.vue?112cfb60